export default "__VITE_ASSET__5f1622cf__"